import { ServiceTokens } from "$src/domain/ServiceTokens";
import type { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { ProjectType } from "$src/domain/customers/ProjectType";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetProjectTypes {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository) {}

    async execute(groupStoreId: number): Promise<ProjectType[]> {
        var types = await this.customerRepository.getProjectTypes(groupStoreId);

        return types;
    }
}

export const GetProjectTypesToken = Symbol('GetProjectTypesToken');    

